/**
 * Created with setting-lib codegen.
 */ import { configuration } from "@faire/web--source/common/settings/declarations/configuration";
/**
 * Controls how long in milliseconds a retailer must dwell (hover or focus) on a category link before it is prefetched.
 */ export var FE_CATEGORY_LINK_SPECULATIVE_PREFETCHING_THRESHOLD_250204 = configuration({
    name: "FE_CATEGORY_LINK_SPECULATIVE_PREFETCHING_THRESHOLD_250204",
    identifier: "RetailerTokenInSession",
    client: "RETAILER",
    defaultValue: 500,
    productArea: "RETAILER_PORTAL"
});
